/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { addDeveloper, getDevelopers } from '../../../db/DeveloperRequestHandler';
import store from '../../../components/stores/Store';

// add dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { getIfFuncAuthorized } from '../../../utils/CheckSomething';
import CheckHandler from '../../../utils/CheckHandler';
import ITextField from '../../../components/UI/ITextField';

const styles = {
  root: {},
  textField: {
    width: '15ch',
  },
  formControl: {
    margin: '10px',
    minWidth: '20ch',
  },
  rootform: {
    textAlign: 'left',
    marginBottom: '10px',
  },
  button: {
    marginLeft: '10px',
    marginTop: '10px',
  }
};
// NavigateLeft
class SelectionOfDeveloperManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      addDeveloperDialogOpen: false,
      addDeveloperParams: {
        name: '',
      },
      dialogMsg: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.addLine = this.addLine.bind(this);
    this.onDevelopDialogChange = this.onDevelopDialogChange.bind(this);
    this.search = this.search.bind(this);
  }

  async componentDidMount() {
    this.search();
    store.search = this.search;
  }
  componentWillUnmount() { }

  onDevelopDialogChange(e, prop) {
    const newAddDeveloperParams = this.state.addDeveloperParams;
    newAddDeveloperParams[prop] = e.target.value;
    e.stopPropagation();

    this.setState({ addDeveloperParams: newAddDeveloperParams });
  }

  async addLine() {
    const name = this.state.addDeveloperParams.name.trim();

    const chkRst = CheckHandler.checkParams([
      { key: '开发商名称', value: name, notNull: true, type: '', maxLength: 64 },
    ]);
    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    const rst = await addDeveloper(this.state.addDeveloperParams);
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '系统错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- rst: `, rst);
      this.search();
      this.setState({
        addDeveloperDialogOpen: false,
        addDeveloperParams: {
          name: '',
        },
      });
      store.openMessageDialogOpen(rst.msg || '添加成功');
      return true;
    }
  }


  async search() {
    if (!getIfFuncAuthorized('房票管理-开发商管理-查找')) {
      store.openMessageDialogOpen('权限不足');
      return;
    }

    console.log(`----- send req of  getDevelopers`);
    const rst = await getDevelopers({});
    console.log(`----- rst of getDevelopers: `, rst);
    if (rst.code === 'error') {
      this.setState({ dialogMsg: rst.msg || '查询错误' });
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- search rst: `, rst);
      store.setTable(rst.data);
      return true;
    }
  }

  handleChange(event) {
    this.setState({ age: event.target.value });
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <form className={classes.rootform} noValidate autoComplete="off">
          {(getIfFuncAuthorized('房票管理-开发商管理-添加')) && (
            <Button
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
              className={classes.button}
              onClick={e => this.setState({ addDeveloperDialogOpen: true })}
            >
              新增
            </Button>
          )}
          <Button
            color="primary"
            variant="contained"
            aria-label="contained primary button group"
            className={classes.button}
            onClick={this.search}
          >
            刷新
          </Button>
        </form>

        <Dialog
          open={this.state.addDeveloperDialogOpen}
          onClose={e => this.setState({ addDeveloperDialogOpen: false })} aria-labelledby="form-dialog-title"
        >
          <DialogTitle
            id="addDeveloperDialog"
            style={{ width: '300px' }}
          >
            添加开发商
          </DialogTitle>
          <DialogContent>
            <ITextField
              autoFocus
              margin="dense"
              id="name"
              label="*开发商名称"
              fullWidth

              ivalue={this.state.addDeveloperParams.name}
              onChange={e => this.onDevelopDialogChange(e, 'name')}
              type=""
              maxLength='64'
              notNull
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.addLine}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              确认添加
            </Button>
            <Button
              onClick={e => this.setState({ addDeveloperDialogOpen: false })}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              取消
            </Button>
          </DialogActions>
        </Dialog>

      </div>
    );
  }
}

const SelectionOfDeveloperManagement = observer(SelectionOfDeveloperManagementInner);

SelectionOfDeveloperManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SelectionOfDeveloperManagement);
